module.exports = __webpack_public_path__ + "img/LTS_MTN_GDP.def6e838.gif";